import React from "react";

const FourSquare = () => {
  return (
    <svg fill="none" viewBox="0 0 12 12">
      <g stroke="#1C1F22" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10">
        <path d="M4 5H2c-.5525 0-1-.4475-1-1V2c0-.5525.4475-1 1-1h2c.5525 0 1 .4475 1 1v2c0 .5525-.4475 1-1 1ZM10 5H8c-.5525 0-1-.4475-1-1V2c0-.5525.4475-1 1-1h2c.5525 0 1 .4475 1 1v2c0 .5525-.4475 1-1 1ZM4 11H2c-.5525 0-1-.4475-1-1V8c0-.5525.4475-1 1-1h2c.5525 0 1 .4475 1 1v2c0 .5525-.4475 1-1 1ZM10 11H8c-.5525 0-1-.4475-1-1V8c0-.5525.4475-1 1-1h2c.5525 0 1 .4475 1 1v2c0 .5525-.4475 1-1 1Z"/>
      </g>
    </svg>
  )
}

export default FourSquare
